import { SxProps, Theme } from '@mui/material';

export const styles: Record<'icon', SxProps<Theme>> = {
  icon: {
    color: (theme) => theme.palette.blue[800],
  },
};
